"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerOffersCMS = void 0;
var DealerOffersCMS = /** @class */ (function () {
    function DealerOffersCMS() {
        this.offers = [{
                offerName: 'BJ\'s Wholesale member exclusive',
                // tslint:disable-next-line: object-literal-sort-keys
                offerId: 'OF_22100066',
                headingCopy: 'BJ\'s Wholesale member exclusive',
                bodyCopy: 'Learn how to get $50 in bill credits when you upgrade to a new smartphone. Other terms apply. ',
                icon: '/idpassets/Partner/BJs_Wholesale/icons/BJs-card.png',
                offerType: 'Special offer for you',
                offerCategory: 'SpecialOffer',
                conditionGroup: 'offertile',
                dealerCode: '9LQN3',
                dealerOffersLegal: {
                    legalModalPath: [
                        '/idpassets/fragment/legal/prod/legalcontent/wireless/offers/dealeroffers/bj_50_lm.cmsfeed.js',
                    ],
                    legalShortPath: {
                        legalText: 'Get $50 in bill credits when you upgrade to a new smartphone. Other terms apply.',
                        shortLegalLinkLabel: 'See offer details',
                    },
                },
            },
        ];
    }
    return DealerOffersCMS;
}());
exports.DealerOffersCMS = DealerOffersCMS;
//# sourceMappingURL=DealerOffers.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeviceOptionsPanel/DeviceCard/DealerOffers.cms.js
// module id = 2043
// module chunks = 8